import ProfileAvatarRing from './ProfileAvatarRing'

export default ProfileAvatarRing
